<main>
    <div class="d-flex flex-row justify-content-center admin-page-header">
        <h1 class="admin-page-title">
            Written Guides
        </h1>
    </div>

    <div class="mediumContainer">
        @if (loading || !loading && trainingCentre.length == 0) {
            <div aria-live="polite" class="w-100 d-flex flex-col align-items-center" role="status">
                @if (loading) {
                    <mat-spinner aria-label="Loading written guides" color="primary"></mat-spinner>
                }
                @if (!loading && trainingCentre.length == 0) {
                    <div class="illustrated-empty-state">
                        <img src="assets/images/reading-character.png" width="431" height="422"
                             alt="Yellow character reading a book">
                        @if (loadFailed) {
                            <h2>We couldn't load the written guides</h2>
                            <p>Please refresh the page to try again.</p>
                        } @else {
                            <h2>Nothing here just yet</h2>
                            <p>No written guides are available for your account right now. Please check back later.</p>
                        }
                    </div>
                }
            </div>
        }
        <div class="memoriesContainer">
            @for (resource of trainingCentre; track resource; let i = $index) {
                <mat-card class="spaceContent">
                    <mat-card-header>
                        <mat-card-title class="mb-0">{{ resource.title }}</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div [innerHTML]="resource.content_rendered || resource.content" class="faqDesc"></div>
                    </mat-card-content>
                    <mat-card-actions class="d-flex flex-row flex-space-around">
                        @if (resource.attachment) {
                            <button (click)="link(resource.attachment, false, resource.title)"
                                    (keyup.enter)="link(resource.attachment, false, resource.title)"
                                    color="primary" mat-raised-button>Download
                            </button>
                        }
                    </mat-card-actions>
                </mat-card>
            }
        </div>
    </div>
</main>
